import { Component, ElementRef, OnInit, ViewEncapsulation, Input, ViewChild } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { TextInputComponent } from "src/app/commons/kymw02/text-input/text-input/text-input.component";
import { KYMW9003Model } from "./kymw9003.model";
import { CellRange, CellType, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { GetAuthoritySetListService } from "./api-services/get-authority-set-list.service";
import { Menu } from "@grapecity/wijmo.input";
import { EventArgs } from "@grapecity/wijmo";
import { KYMW9004Component } from "../kymw9004/kymw9004.component";
import { KYMW9004InputModel } from "../kymw9004/vo/kymw9004-input.model";

@Component({
	selector: 'app-kymw9003',
	templateUrl: 'kymw9003.component.html',
	styleUrls: ['kymw9003.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class KYMW9003Component extends PlessViewHelperSub implements OnInit {

	public kymw9003Model: KYMW9003Model = new KYMW9003Model();

	/** コンテキストメニュー */
	private contextMenu: Menu;

	/** 再検索要否確認用 */
	public searchFlag: Boolean = <boolean>false;

	/** 新規登録ボタン活性制御用 */
	public disabledRegist: Boolean = <boolean>false;

	@ViewChild('dg_AuthoritySetList', { static: true }) dg_AuthoritySetList: FlexGrid;
	@ViewChild('tbx_authority', { static: true }) tbx_authority: TextInputComponent;

	/**
	 * Creates an instance of KYMW9000Component.
	 * @param {PlessDialogServiceSub} dialogService
	 * @param {KYMW00Model} kymw00Model
	 * @param {ElementRef} elementRef
	 * @memberof KYMW9000Component
	 */
	constructor(
		private dialogService: PlessDialogServiceSub,
		private kymw00Model: KYMW00Model,
		private elementRef: ElementRef,
		public getAuthoritySetListService: GetAuthoritySetListService,
	) {
		super(kymw00Model);
	}

	/**
	 * 初期処理
	 *
	 * @memberof KYMW9000Component
	 */
	public ngOnInit(): void {
		this.componentName = 'KYMW9003';
		this.kymw9003Model.kymw9003Component = this;

		// コンテキストメニューの設定
		this.setContextMenu();

		// グリッドの初期選択行はなしとする
		this.dg_AuthoritySetList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
			this.dg_AuthoritySetList.select(-1, -1);
		});

		// 初期フォーカス
		this.tbx_authority.setFocus();

		// フルコントロール権限以外は新規登録ボタンを非活性とする
		if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
			this.disabledRegist = true;
		}
	}

	/**
	 * 表示ボタン押下時
	 * 
	 */
	public eventDisplayAuthoritySetList_CLICKHandler(): void {
		this.getAuthoritySetListService.execute(this.kymw9003Model, (data) => {
			if (this.kymw9003Model.authoritySetList == null || this.kymw9003Model.authoritySetList.length === 0) {
				this.dialogService.openAlertGetMessage("W0049");
			}
		});
		this.searchFlag = true;
	}

	/**
	 * 表のコンテキストメニュー設定
	 * 
	 */
	private setContextMenu(): void {
		this.contextMenu = new Menu(document.createElement('div'),
			{
				displayMemberPath: 'caption',
				selectedValuePath: 'cmd',
				itemsSource: [
					{ caption: '権限情報編集', cmd: 'authorityInfoEdit', enabled: true },
				],
				command: this.getFormatMenuCommand(),
				itemClicked: (s, e) => {
					switch (this.contextMenu.selectedValue) {
						case 'authorityInfoEdit':
							this.eventEditAuthority();
							break;
					}
				}
			}
		);

		// 右クリック押下時 コンテキストメニュー表示処理
		this.dg_AuthoritySetList.hostElement.addEventListener('contextmenu', (e: any) => {
			// イベントを停止後、メニュー表示
			e.preventDefault();
			if (this.contextMenu !== undefined) {
				this.eventContextMenu_SELECTHandler(e);
				this.contextMenu.show(e);
			}
		});
	}

	/**
	 * メニュー項目活性・非活性制御
	 *
	 * @private
	 * @returns {*}
	 * @memberof KYMW9000Component
	 */
	private getFormatMenuCommand(): any {
		return {
			canExecuteCommand: (param) => {
				// 各項目の活性制御
				return (param.enabled === false) ? false : true;
			}
		};
	}

	/**
	 * コンテキストメニューを呼び出した際のイベント
	 * @param event 呼び出し元イベントへの参照
	 */
	public eventContextMenu_SELECTHandler(event: any): void {

		// コンテキストメニューの利用可能不可判断フラグ
		let contextMenuEnabledMode = Boolean(true);

		const ht = this.dg_AuthoritySetList.hitTest(event.pageX, event.pageY);
		// 右クリック押下時に対象行を選択状態にする
		const grid = new CellRange(ht.row, ht.col);
		this.dg_AuthoritySetList.select(grid, false);

		// 権限確認
		if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
			// フルコントロール権限以外であれば非活性
			contextMenuEnabledMode = false;
		} else {
			// 選択している行が存在するか確認
			if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dg_AuthoritySetList.selectedRows))) {
				// 行がない時は非活性
				contextMenuEnabledMode = false;
			} else {
				// 選択行がある場合は対象行の権限を確認
				const authoritySetId = this.dg_AuthoritySetList.rows[ht.row].dataItem.authoritySetId;
				if (authoritySetId === '00' || authoritySetId === '99') {
					// 権限が新規と削除は非活性
					contextMenuEnabledMode = false;
				}
			}
		}

		// コンテキストメニューの活性制御
		this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
			item.enabled = contextMenuEnabledMode;
		});
	}

	/**
	 * コンテキストメニュー「権限情報編集」が選ばれた時
	 * 
	 */
	public eventEditAuthority(): void {
		const reqVO = new KYMW9004InputModel();
		reqVO.authoritySetId = this.dg_AuthoritySetList.selectedItems[0].authoritySetId;
		this.openKYMW9004(reqVO);
	}

	/** 
	 * 新規登録ボタン押下時
	 * 
	 */
	public eventRegistBtn_CLICKHandler(): void {
		const reqVO = new KYMW9004InputModel();
		reqVO.authoritySetId = "";
		this.openKYMW9004(reqVO);
	}

	/**
	 * KYMW9004 権限設定画面を呼び出す
	 * @param vo KYMW9004InputModel
	 */
	public openKYMW9004(vo) {
		const componentRef = this.dialogService.openModal(KYMW9004Component);
		const instance = componentRef.componentInstance as KYMW9004Component;
		instance.parent = this;
		instance.setInterfaceParam(vo);
		instance.closeFunction = () => {
			componentRef.close();
			if (this.searchFlag) {
				//  モーダル画面表示前の検索条件で権限情報を再検索する
				this.getAuthoritySetListService.execute(this.kymw9003Model);
			}
		};
	}
}
